const darkPalette = {
  greyTheme: {
    palette: {
      primary: {
        light: '#eceff1',
        main: '#607d8b',
        dark: '#37474f',
        contrastText: '#fff',
      },
      secondary: {
        light: '#e0e0e0',
        main: '#757575',
        dark: '#263238',
        contrastText: '#fff',
      },
    },
  },
  lightBlueTheme: {
    palette: {
      primary: {
        light: '#b3e5fc',
        main: '#03a9f4',
        dark: '#0277bd',
        contrastText: '#fff',
      },
      secondary: {
        light: '#e0f7fa',
        main: '#00bcd4',
        dark: '#00838f',
        contrastText: '#fff',
      },
    },
  }
};

export default darkPalette;
